<script>
  import { writable } from "svelte/store";
  import { HStack, VStack, MediaQuery } from "../layout";
  import { Button, Label } from "../widget";
  import { toLocaleDate } from "../../date.js";
  import { showNotification } from "../../dialog.js";
  import { load, create, update, BLOG_LOGO } from "../../articles.js";
  export let wedding;
  export let isOwner;
  export let isEdit;

  let wedding_name = wedding.name;
  let date = toLocaleDate(wedding.wedding_date);

  let created_id = null;
  const submit = async (title, category, content, articleId, published) => {
    try {
      if (articleId) {
        let r = await update(wedding.guid, articleId, title, category, JSON.stringify(content), published);
        created_id = articleId;
      } else {
        let r = await create(wedding.guid, title, category, JSON.stringify(content));
        created_id = r.data.id;
      }
    } catch (e) {
      let msg = e.toString();
      if (msg == "Error: 401 - 22 Access Denied.") {
        msg = "Vous êtes déconnecté - Reconnexion en cours...";
        return showNotification({ text: msg, error: true }).then(() => {
          window.location.reload(true);
        });
      }
      return Promise.reject(e);
    }
  };

  let logoBannerArticle = writable(undefined);

  const loadBanner = async () => {
    return load(wedding.guid, BLOG_LOGO)
      .then((r) => {
        logoBannerArticle.set(r[0]);
      })
      .catch((e) => {
        logoBannerArticle.set(undefined);
        return Promise.reject(e);
      });
  }

  let bannerFileinput;
  let logoBannerArticleId = undefined;
  let logoBannerArticleImage = undefined;
  logoBannerArticle.subscribe( (a) => { 
    if (a) { 
      logoBannerArticleId = a.id
      logoBannerArticleImage = JSON.parse(a.content)
    } 
  })

  const onBannerFileChange = async (e) => {
    let image = e.target.files[0];
    let reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = e => {
            submit("Blog Banner", BLOG_LOGO, {image: e.target.result}, logoBannerArticleId, true).then(() => {
              loadBanner()
            })
      };
  }

  const refresh = async () => {
    return Promise.all([loadBanner()])
      .catch((e) => {
        console.log(e);
      })
  };

  $: {
    if (wedding !== undefined) {
      refresh();
    }
  }

</script>

<article>
  {#if logoBannerArticleImage}
    <img class="banner" src="{logoBannerArticleImage.image}" alt="banner" />
  {:else} 
    <img class="banner" src="images/banner/[1x]-banner-blog.jpg" alt="banner" />
  {/if}
  <section>
    <VStack>
      <h1>{wedding_name}</h1>
      {#if wedding.hasDateInBlog}
        <h2>{date}</h2>
      {/if}
      {#if wedding.hasTamponInBlog}
        <MediaQuery query="(min-width: 481px)">
          <img class="tampon" src="./images/lucie_bapteme_transparent.png" alt="tampon" width="300px" height="300px" />
          <img
            slot="else"
            class="tampon"
            src="./images/lucie_bapteme_transparent.png"
            alt="tampon"
            width="150px"
            height="150px" />
        </MediaQuery>
      {/if}
    </VStack>
  </section>
  {#if isOwner && isEdit}
    <div class="upload">
      <HStack justify="right">
        <Button action={() => bannerFileinput.click() }>
          <Label size="32" icon="file-upload" />
        </Button>
        <input style="display:none" type="file" accept=".jpg, .jpeg, .png" on:change={(e)=>onBannerFileChange(e)} bind:this={bannerFileinput} >
      </HStack>
    </div>
  {/if}
</article>

<style>
  article {
    position: relative;
    font-family: Cinzel;
    color: var(--primary-color);
  }

  h1 {
    font-size: 30px;
    text-align: center;
  }

  img.banner {
    width: 100%;
    height: 320px;
    object-fit: cover;
  }

  section {
    /* height: 320px; */
    width: 100%;
    max-width: 460px;
    position: absolute;
    background-color: rgba(255, 255, 255, 0.7);
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  div.upload {
    position: absolute;
    right: 0;
    bottom: 10px;
  }

  @media screen and (min-width: 321px) {
    h1 {
      font-size: 32px;
    }
  }

  @media screen and (min-width: 481px) {
    h1 {
      font-size: 38px;
    }
    img.banner {
      height: 460px;
    }
    section {
      /* height: 460px; */
    }
  }

  h2 {
    margin-top: 0;
    text-align: center;
  }

  .tampon {
    margin: 0 auto;
  }
</style>
